import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-projects9',
  templateUrl: './section-projects9.component.html',
  styleUrls: ['./section-projects9.component.css']
})
export class SectionProjects9Component implements OnInit {

  @Input() data: any;
  
  constructor() { }

  ngOnInit(): void {
  }

}
